import User from "~/records/record.user.jsx";
import {
  LOGOUT_USER,
  SUBMIT_BASIC_DETAILS_ONBOARDING_SUCCESS,
  SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_SUCCESS,
} from "~/store/action_types";
import { LOAD_LOGGED_USER, ANGULAR_INIT, EDIT_LOGGED_USER_SUCCESS } from "~/store/action_types";

const logged_user = (state = new User(), action) => {
  switch (action.type) {
    case SUBMIT_BASIC_DETAILS_ONBOARDING_SUCCESS:
    case EDIT_LOGGED_USER_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { users = {} } = entities;

      const { single: id } = result;

      if (users[id]) {
        return new User({
          ...state.toObject(),
          ...users[id],
        });
      }

      return state;
    }
    case SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { users = {} } = entities;

      if (result?.user) {
        return new User({
          ...state.toObject(),
          ...users[result.user],
        });
      }

      return state;
    }
    case LOAD_LOGGED_USER:
      return new User({
        ...state.toObject(),
        ...action.response,
      });
    case ANGULAR_INIT:
      return new User({
        ...state.toObject(),
        ...action.response.logged_user,
      });
    case LOGOUT_USER: {
      return new User();
    }
    default:
      return state;
  }
};

export default logged_user;
